import { Component, AfterViewInit, OnInit } from '@angular/core';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import 'jquery-slimscroll';
import { AuthService, AppInformationService } from '../../core/core.module';
import { DevExtremeModule } from 'devextreme-angular';
import { CommonModule } from '@angular/common';

declare var jQuery: any;

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'navigation',
    templateUrl: 'navigation.template.html',
    imports: [CommonModule, DevExtremeModule, RouterLink, RouterLinkActive],
    standalone: true,
})
export class NavigationComponent implements OnInit, AfterViewInit {
    version: string;

    constructor(private router: Router, public auth: AuthService, public appInfo: AppInformationService) {}

    async ngOnInit() {}

    ngAfterViewInit() {
        jQuery('#side-menu').metisMenu();

        if (jQuery('body').hasClass('fixed-sidebar')) {
            jQuery('.sidebar-collapse').slimscroll({
                height: '100%',
            });
        }
    }

    activeRoute(routeName: string): boolean {
        return this.router.url.indexOf(routeName) > -1;
    }

    hasRole(role: string) {
        return this.auth.hasRole(role);
    }

    showCalendar() {
        return this.auth.hasRole('Administrator') || this.auth.hasRole('Secretary') || this.auth.hasRole('Executive');
    }

    showPeople() {
        if (this.appInfo.graafschap) {
            return (
                this.auth.hasRole('Administrator') ||
                this.auth.hasRole('Members') ||
                this.auth.hasRole('Secretary') ||
                this.auth.hasRole('PeopleAdmin') ||
                this.auth.hasRole('GCEOFAdmin')
            );
        } else {
            return this.auth.hasRole('Administrator') || this.auth.hasRole('Members');
        }
    }
    showGroups() {
        if (this.appInfo.graafschap) {
            return this.auth.hasRole('Administrator') || this.auth.hasRole('Members') || this.auth.hasRole('Secretary') || this.auth.hasRole('PeopleAdmin');
        }
    }
    showMemberManagement() {
        if (this.appInfo.graafschap) {
            return this.auth.hasRole('PeopleAdmin') || this.auth.hasRole('Administrator');
        }
    }
    showCommittees() {
        if (this.appInfo.graafschap) {
            return this.auth.hasRole('PeopleAdmin') || this.auth.hasRole('People:Committee') || this.auth.hasRole('Administrator');
        }
    }
    showHouseholds() {
        return this.auth.hasRole('PeopleAdmin') || this.auth.hasRole('Administrator');
    }
    showVisits() {
        if (this.appInfo.graafschap) {
            return this.auth.hasRole('Visits');
        } else {
            return false;
        }
    }
    showDeaconVisits() {
        if (this.appInfo.graafschap) {
            return (this.auth.hasRole('Giving') && !this.auth.hasRole('Secretary') && !this.auth.hasRole('Executive')) || this.auth.hasRole('Administrator');
        } else {
            return false;
        }
    }
    showNursery() {
        if (this.appInfo.graafschap) {
            return (
                (this.auth.currentUser && (this.auth.currentUser.userName === 'mreimink' || this.auth.currentUser.userName === 'jgeurink')) || this.auth.hasRole('NurseryCheckIn')
            );
        } else {
            return false;
        }
    }
    showMessages() {
        if (this.appInfo.graafschap) {
            return this.auth.hasRole('Administrator') || this.auth.hasRole('Members') || this.auth.hasRole('Secretary') || this.auth.hasRole('Messages');
        } else {
            return this.auth.hasRole('Members');
        }
    }
    showTextMessages() {
        if (this.appInfo.graafschap) {
            return this.auth.hasRole('Administrator') || this.auth.hasRole('Messages');
        }
    }

    showInterests() {
        return this.auth.hasRole('Interests');
    }

    showInvolvement() {
        return this.auth.hasRole('Involvement');
    }

    showBackgroundChecks() {
        return this.auth.hasRole('Background Checks');
    }

    showInvoices() {
        return this.auth.hasRole('Administrator') || this.auth.hasRole('Invoices');
    }

    showGiving() {
        if (this.appInfo.graafschap) {
            return this.auth.hasRole('Administrator') || this.auth.hasRole('Giving');
        } else {
            return this.auth.hasRole('Administrator') || this.auth.hasRole('Giving') || this.auth.hasRole('Treasurer') || this.auth.hasRole('Accountant');
        }
    }

    showPledges() {
        if (this.appInfo.neland) {
            return this.auth.hasRole('Administrator') || this.auth.hasRole('Giving');
        } else return this.auth.hasRole('Administrator') || this.auth.hasRole('PledgesAdmin');
    }

    showGivingOverview() {
        if (this.appInfo.graafschap) {
            return this.auth.hasRole('Administrator') || this.auth.hasRole('Giving');
        } else {
            return true;
        }
    }

    showBatches() {
        if (this.appInfo.graafschap) {
            return this.auth.hasRole('Giving') || this.auth.hasRole('Administrator');
        } else {
            return this.auth.hasRole('Giving') || this.auth.hasRole('Treasurer') || this.auth.hasRole('Accountant') || this.auth.hasRole('Administrator');
        }
    }

    showClassis() {
        if (this.appInfo.graafschap) {
            return !this.auth.hasRole('Executive') || this.auth.hasRole('Administrator');
        } else {
            return false;
        }
    }

    showStatements() {
        if (this.appInfo.graafschap) {
            return this.auth.hasRole('Administrator') || this.auth.hasRole('Treasurer') || this.auth.hasRole('Deacon');
        } else {
            return this.auth.hasRole('Administrator') || this.auth.hasRole('Treasurer');
        }
    }

    showAccounts() {
        if (this.appInfo.graafschap) {
            return (
                this.auth.hasRole('Administrator') ||
                this.auth.hasRole('Giving') ||
                this.auth.hasRole('Accounts') ||
                this.auth.hasRole('Accounts:Admin') ||
                this.auth.hasRole('Secretary')
            );
        } else {
            return this.auth.hasRole('Treasurer') || this.auth.hasRole('Accountant');
        }
    }

    showReports() {
        if (this.appInfo.graafschap) {
            return this.auth.hasRole('Giving') || this.auth.hasRole('Administrator');
        } else {
            return false;
        }
    }

    showReconciliation() {
        if (this.appInfo.graafschap) {
            return this.auth.hasRole('Administrator') || this.auth.hasRole('Treasurer') || this.auth.hasRole('Deacon');
        } else {
            return false;
        }
    }
    showDeposits() {
        return this.auth.hasRole('Administrator') || this.auth.hasRole('Treasurer');
    }

    showGivingInstructions() {
        if (this.appInfo.graafschap) {
            return this.auth.hasRole('Administrator') || this.auth.hasRole('Giving');
        } else {
            return false;
        }
    }
    showMemberPortal() {
        if (this.appInfo.graafschap) {
            return this.auth.hasRole('Administrator') || this.auth.hasRole('Generic');
        } else {
            return false;
        }
    }
    showNominations() {
        if (this.appInfo.graafschap) {
            return this.auth.hasRole('Administrator') || this.auth.hasRole('Nominations') || this.auth.hasRole('Nominations:Admin');
        } else {
            return false;
        }
    }
    showExecutive() {
        if (this.appInfo.graafschap) {
            return this.auth.hasRole('Administrator') || this.auth.hasRole('Executive');
        } else {
            return false;
        }
    }
    showExecutiveClerk() {
        if (this.appInfo.graafschap) {
            return this.auth.hasRole('Administrator') || this.auth.hasRole('Executive:Clerk');
        } else {
            return false;
        }
    }
    showExecutiveMinutes() {}
    showExecutiveDocuments() {
        if (this.appInfo.graafschap) {
            return this.auth.hasRole('Administrator') || this.auth.hasRole('Executive:Documents');
        } else {
            return false;
        }
    }
    showExecutiveProposals() {
        if (this.appInfo.graafschap) {
            return this.auth.hasRole('Administrator') || this.auth.hasRole('Executive:Proposals');
        } else {
            return false;
        }
    }
    showExecutiveNominations() {
        if (this.appInfo.graafschap) {
            return this.auth.hasRole('Administrator') || this.auth.hasRole('Executive:Nominations');
        } else {
            return false;
        }
    }
    showExecutiveReports() {
        if (this.appInfo.graafschap) {
            return this.auth.hasRole('Executive') || this.auth.hasRole('Administrator');
        } else {
            return false;
        }
    }
    showCommitteeDocuments() {
        if (this.appInfo.graafschap) {
            return this.auth.hasRole('Administrator') || this.auth.hasRole('Treasurer');
        } else {
            return false;
        }
    }
    showFinance() {
        if (this.appInfo.graafschap) {
            return this.auth.hasRole('Administrator') || this.auth.hasRole('Finance') || this.auth.hasRole('Treasurer');
        } else {
            return false;
        }
    }
    showAdmin() {
        return this.auth.hasRole('Administrator');
    }
}
